module.exports = __webpack_public_path__ + "img/depmap_svg_V126.a497da53.svg";